/**
 * ScatterPlotEditor
 *
 * Property editor for scatter plot configuration
 */

import React from 'react';
import { ChartBaseEditor, type ChartBaseConfig } from './ChartBaseEditor';
import { TextPropertyEditor } from '../../BaseEditors/TextPropertyEditor';
import { NumberPropertyEditor } from '../../BaseEditors/NumberPropertyEditor';

export interface ScatterPlotEditorProps {
  config: Partial<ChartBaseConfig & {
    xAxisKey?: string;
    yAxisKey?: string;
    dotSize?: number;
  }>;
  onChange: (config: Partial<ChartBaseConfig>) => void;
}

export const ScatterPlotEditor: React.FC<ScatterPlotEditorProps> = ({ config, onChange }) => {
  return (
    <ChartBaseEditor config={config} onChange={onChange} chartType="Scatter Plot" showAxes>
      <div className="chart-editor__section">
        <h3 className="chart-editor__section-title">Scatter Plot Options</h3>

        <TextPropertyEditor
          label="X Axis Data Key"
          value={(config.xAxisKey as string) || 'x'}
          onChange={(xAxisKey) => onChange({ ...config, xAxisKey })}
          placeholder="e.g., x, valueX"
          helpText="Property name for X coordinates"
          required
        />

        <TextPropertyEditor
          label="Y Axis Data Key"
          value={(config.yAxisKey as string) || 'y'}
          onChange={(yAxisKey) => onChange({ ...config, yAxisKey })}
          placeholder="e.g., y, valueY"
          helpText="Property name for Y coordinates"
          required
        />

        <NumberPropertyEditor
          label="Dot Size"
          value={(config.dotSize as number) || 6}
          onChange={(dotSize) => onChange({ ...config, dotSize })}
          min={2}
          max={20}
          step={1}
          helpText="Radius of data points"
          suffix="px"
        />
      </div>
    </ChartBaseEditor>
  );
};

ScatterPlotEditor.displayName = 'ScatterPlotEditor';
